<template>
  <div class="multi-line">
    <template v-for="(e, i) in rows">
      <span :class="{ 'share-out': shareOut }" :key="`text_${i}`">
        {{ e }}
      </span>
    </template>
  </div>
</template>

<script>
import { getResolutionSymbol } from '@/utils/utils';
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    shareOut: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rows() {
      const symbol = getResolutionSymbol();
      if (symbol === 'xl') {
        return [this.text.replace(/\s/g, '')];
      } else {
        return this.text.split(' ');
      }
    }
  }
};
</script>

<style lang="scss">
.multi-line {
  display: inline-block;

  .share-out {
    display: block;
    width: 100%;
    text-align: justify;
    text-align-last: justify;
  }
}
</style>
